import $ from 'jquery'
import _ from 'lodash'
import Backbone from 'backbone'
import template from './tree-fixer.hbs'
import FormView from 'scoreboard/components/form-view'
import i18n from 'scoreboard/components/i18n'
import metadata from 'scoreboard/components/metadata'

var TreeFixer = Backbone.View.extend({

	tagName: 'form',

	className: 'tree-fixer',

	/**
	 * Scans for corrupt trees in the database and displays whether any were
	 * found.
	 *
	 * @constructs
	 */
	initialize(options = {}) {
		this.options = options
		this.formView = new FormView({
			el: this.el,
			allowCleanSubmission: true,
			submit: this.submit.bind(this)
		})
	},

	render: function() {
		this.$el.empty().append(template())
		this.formView.start()
		return this
	},

	submit: function() {
		// if we already ran the tree fixer
		if (this.results) {
			// close the dialog
			this.trigger('done')
			return
		}

		this.$('.cancel').remove()
		$.post('api/admin/fix-trees', results => {
			if (_.isEmpty(results)) {
				this.$('.description').text(i18n.get('admin.treeFixer.noneCorrupt'))
			} else {
				let msg = i18n.get('admin.treeFixer.fixed.banner')
				this.$('.description').html(`${msg}<ul></ul>`)
				_.each(results, (fixes, domainType) => {
					let bullet = i18n.get('admin.treeFixer.fixed.description',
						_.size(fixes),
						i18n.get(metadata[domainType].pluralCode))
					this.$('.description ul').append(`<li>${bullet}</li>`)
				})
			}
			this.results = results
			this.$('.button-primary').text(i18n.get('common.done'))
			this.formView.start()
		})
	},

	remove() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.formView], 'remove')
	}

})

export default TreeFixer

TreeFixer.__filename__ = 'admin/tree-fixer.js'
